import { styled } from 'styled-components';
export const DrawerContent = styled.div.withConfig({
  componentId: "aui__sc-2s51kz-0"
})(["box-sizing:border-box;width:100%;flex:auto;overflow-x:hidden;overflow-y:scroll;"]);